import Cookies from "js-cookie";
import { getCurrentEnviornment } from "utils/constants";

export async function APIHandlerSimulation({
  method,
  url,
  data,
  isM2CBackendUrl,
}: any) {
  const myAuth = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);
  const userEmail = localStorage.getItem("userEmail");
  const combineURL = (url: any) => {
    const baseUrl = process.env.REACT_APP_SimulationBaseServerURL;
    return baseUrl + url;
  };

  const raw = JSON.stringify(data);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  // myHeaders.append("Authorization", `${myAuth}`);
  // myHeaders.append("Email", `${userEmail}`);

  const requestOptions: any = {
    method: method,
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(combineURL(url), requestOptions);
    const result = await response.text();
    const res = JSON.parse(result);

    if (res === "Logged Out") {
      Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
      window.location.replace("/");
    }

    return res; // Return the fetched data
  } catch (error) {
    console.error(error);
    throw error; // Rethrow the error for handling in the calling function
  }
}
